/**
 * @file index.js
 * @description Frontend entrypoint that registers all custom elements.
 */

// used everywhere
import "/src/components/trackerPopupComponent.js";

const path = window.location.pathname;

switch (path) {
  case "/":
    import("/src/components/showFirstEvent.js");
    break;
  case "/software":
    import("/src/components/pdfViewer/pdfViewer.js");
    import("/src/components/pdfViewer/pdfUtils.js");
    break;
  case "/careers":
    import("/src/components/jobComponent.js");
    break;
  case "/partners":
    import("/src/components/partnerComponent.js");
    break;
  case "/events":
    import("/src/components/eventComponent.js");
    break;
  case "/admin":
    import("/src/components/jobComponent.js");
    import("/src/components/eventComponent.js");
    import("/src/components/adminLoginComponent.js");
    import("/src/components/userDataComponent.js");
    import("/src/components/pdfDataComponent.js");
    import("/src/components/gdprDataComponent.js");
    break;
}

//utils

function styleCurrentPageLink() {
  const links = document.querySelectorAll("li");
  Array.from(links).forEach(li => {
    const link = li.querySelector("a");

    if (link && link.pathname === window.location.pathname) {
      li.classList.add("active");
    }
  });
}

function setYear() {
  const year = document.getElementById("year")
  year.textContent = new Date().getFullYear();
}


styleCurrentPageLink();
setYear();
